import { classnames } from '@src/utils/classnames';
import * as React from 'react';
import { GroupBase } from 'react-select';
import { Icon } from '@src/atoms/Icon';
import { ISelectDropdownIndicatorProps, IOptionBase } from '../models';
import styled from './SelectDropdownIndicator.module.scss';

export const SelectDropdownIndicator = <OptionType extends IOptionBase, GroupType extends GroupBase<OptionType>>({
  selectProps,
}: ISelectDropdownIndicatorProps<OptionType, GroupType, false>) => {
  const { isDisabled, isIndicator, menuIsOpen } = selectProps;

  const classes = classnames(styled.root, {
    [styled.root_isDisabled]: isDisabled,
    [styled.root_up]: menuIsOpen,
  });

  return isIndicator && <Icon name="triangle" className={classes} size="md-light" />;
};
